import { render, staticRenderFns } from "./FormCompletedTask.vue?vue&type=template&id=40471e35"
import script from "./FormCompletedTask.vue?vue&type=script&lang=js"
export * from "./FormCompletedTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormCompletedTask.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40471e35')) {
      api.createRecord('40471e35', component.options)
    } else {
      api.reload('40471e35', component.options)
    }
    module.hot.accept("./FormCompletedTask.vue?vue&type=template&id=40471e35", function () {
      api.rerender('40471e35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/components/FormCompletedTask.vue"
export default component.exports